import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    this.menuTarget.classList.toggle("hidden");
  }

  close(_event) {
    // Close the dropdown without preventing default behavior
    // This allows links to navigate normally
    this.menuTarget.classList.add("hidden");
  }

  connect() {
    // Close dropdown when clicking outside
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.boundHandleClickOutside, true);
  }

  disconnect() {
    if (this.boundHandleClickOutside) {
      document.removeEventListener("click", this.boundHandleClickOutside, true);
    }
  }

  handleClickOutside(event) {
    // Don't close if clicking inside the dropdown element
    if (this.element.contains(event.target)) {
      return;
    }
    
    // Close the dropdown
    this.close();
  }
}

